// extracted by mini-css-extract-plugin
export default {"app":"Layout_app__Y3jX6","fadeIn":"Layout_fadeIn__0Qg0j","fade-in":"Layout_fade-in__kynDB","page":"Layout_page__z-Iv3","paintingsGrid":"Layout_paintingsGrid__l87Xm"};